import { combineReducers } from 'redux'

import authenticationReducer from './authenticationReducer'
import projectBoardReducer from './projectBoardReducer'
import listingReducer from './listingReducer'

export default combineReducers({
  authentication: authenticationReducer,
  projectBoard: projectBoardReducer,
  listing: listingReducer,
})
